import axios from 'axios'
import getHeaders from '../../helpers/headers'
import config from '../../../constants/endpoints.js'
const {
  endpoints: {
    plugins: {
      search: { query, results, cancelSearch },
    },
  },
} = config

/**
 * Search a product for a user.
 *
 * @param {Object} data.user User object
 * @param {Object} data.query Product query to search
 * @param {String} data.type Product type for search
 */
const searchProduct = (data) => axios.post(query, data, { headers: getHeaders(true) })

/**
 * Check search status for a job.
 *
 * @param {String} params.jobId Job id of the query
 * @param {String} params.type Product type
 * @param {Number} params.from Get results from this number
 * @param {Number} params.size Number of results to get
 * @param {String} product Product
 */
const getSearchResults = (params) => axios.get(results, { headers: getHeaders(true), params })

/**
 * Watch a job given its token.
 *
 * @param {String} params.token Token of the job, returned after sending search action
 */
const watchJob = ({ token }) => axios.get(`${query}/${token}`, { headers: getHeaders(true) })

/**
 * Cancel a product search.
 *
 * @param {Object} data.user User object
 * @param {String} data.token Search token
 */
const cancelProductSearch = (data) => axios.get(`${cancelSearch}/${data.token}`, { headers: getHeaders(true) })

/**
 * Send results to the user.
 *
 * @param {Object} data.user User object
 * @param {Object} data.query Product query
 * @param {String} data.type Product type
 * @param {String} data.jobId Job id of the product
 * @param {Boolean} data.acivate Activate the user after sending results
 * @param {Array} data.results Array of product objects, empty if sending all
 */
const sendResults = (data) => axios.post(results, data, { headers: getHeaders(true) })

export default {
  searchProduct,
  getSearchResults,
  watchJob,
  cancelProductSearch,
  sendResults,
}
